import { getConfig } from 'common/axios/jwt/state';
import { ICreds, LS_CREDS_KEY } from 'common/axios/jwt/types';

export const getCreds = (): ICreds => {
  try {
    const raw = localStorage.getItem(LS_CREDS_KEY);
    if (!raw) {
      return {};
    }
    return JSON.parse(raw) as ICreds;
  } catch {
    return {};
  }
};

export const saveCreds = (creds: ICreds): ICreds => {
  localStorage.setItem(LS_CREDS_KEY, JSON.stringify(creds));
  const config = getConfig();
  if (config && creds.access?.token) {
    config.axios.defaults.headers.common['Authorization'] = `Bearer ${creds.access.token}`;
  }
  return creds;
};

export const clearCreds = (): void => {
  localStorage.removeItem(LS_CREDS_KEY);
  const config = getConfig();
  if (config) {
    delete config.axios.defaults.headers.common['Authorization'];
  }
};
